import WebUtils from "../utils/WebUtils";

export const addtoVideoQueue = (
  formData,
  apiVideoQueue,
  videoBlobQueueRef,
  formUrl,
  videoRejoinApiFlag,
  videoRejoinApi
) => {
  const queueItem = {
    formData,
    rejoinFlag: videoRejoinApiFlag.current,
  };
  apiVideoQueue.current.push(queueItem);
  videoBlobQueueRef.current.push(formData);
  videoRejoinApiFlag.current = false;

  // console.log("Api Video queue", apiVideoQueue.current);
  // console.log("Video queue", videoBlobQueueRef.current);

  if (apiVideoQueue.current.length === 1) {
    processVideoQueue(
      apiVideoQueue,
      videoBlobQueueRef,
      formUrl,
      videoRejoinApi
    );
  }
};

const processVideoQueue = async (
  apiVideoQueue,
  videoBlobQueueRef,
  formUrl,
  videoRejoinApi
) => {
  while (apiVideoQueue.current.length > 0) {
    const item = apiVideoQueue.current[0];
    const { formData } = item;

    try {
      await makeVideoApiCall(
        formData,
        item.rejoinFlag ? true : false,
        formUrl,
        videoRejoinApi
      );
    } catch (error) {
      console.error("Error uploading video", error);
    } finally {
      apiVideoQueue.current.shift();
      videoBlobQueueRef.current.shift();
    }
  }
};

const makeVideoApiCall = async (
  formData,
  rejoinFlag,
  formUrl,
  videoRejoinApi
) => {
  return WebUtils.httpOperations(formUrl, formData, "POST")
    .then((response) => {
      if (response.data.resultStatusInfo.resultCode === "SUCCESS") {
        if (rejoinFlag) {
          videoRejoinApi();
        }
      }
    })
    .catch((err) => console.error(err));
};
